// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import "./styles.css";
import "./components/icon-controls.css";
import * as ReactDOMClient from "react-dom/client";
import * as jsxRuntime from "react/jsx-runtime";
import * as React from "react";
import { App } from "./App.jsx";
import { LoginGate } from "./features/auth/LoginGate.jsx";
import { PaymentReturn } from "./features/shop/PaymentReturn.jsx";
import { PwaProvider } from "./features/pwa/PwaProvider.jsx";
import { registerPwaServiceWorker } from "./features/pwa/register.js";
export const telegramApp = window.Telegram?.WebApp;
export const MIN_FULLSCREEN_CONTENT_TOP = 84;
export const syncTelegramInsets = () => {
  if (!telegramApp) return;
  const u = Math.max(telegramApp.safeAreaInset?.top ?? 0, telegramApp.contentSafeAreaInset?.top ?? 0),
    o = Math.max(telegramApp.safeAreaInset?.bottom ?? 0, telegramApp.contentSafeAreaInset?.bottom ?? 0);
  document.documentElement.style.setProperty("--meta-safe-top", `${u}px`), document.documentElement.style.setProperty("--meta-safe-bottom", `${o}px`), document.documentElement.style.setProperty("--meta-fullscreen-controls-top", telegramApp.isFullscreen ? `${Math.max(0, MIN_FULLSCREEN_CONTENT_TOP - u)}px` : "0px");
};
telegramApp?.ready();
telegramApp?.expand();
(telegramApp?.platform === "ios" || telegramApp?.platform === "android") && (telegramApp.requestFullscreen?.(), telegramApp.disableVerticalSwipes?.(), telegramApp.lockOrientation?.());
telegramApp?.setHeaderColor?.("#0a0d18");
telegramApp?.setBackgroundColor?.("#080a13");
syncTelegramInsets();
if (import.meta.env.PROD) registerPwaServiceWorker();
telegramApp?.onEvent?.("safeAreaChanged", syncTelegramInsets);
telegramApp?.onEvent?.("contentSafeAreaChanged", syncTelegramInsets);
telegramApp?.onEvent?.("fullscreenChanged", syncTelegramInsets);
ReactDOMClient.createRoot(document.getElementById("root")).render(jsxRuntime.jsx(React.StrictMode, {
  children: jsxRuntime.jsx(PwaProvider, {
    children: new URLSearchParams(window.location.search).has("tbank_order")
      ? jsxRuntime.jsx(PaymentReturn, { orderId: new URLSearchParams(window.location.search).get("tbank_order") })
      : jsxRuntime.jsx(LoginGate, { children: jsxRuntime.jsx(App, {}) })
  })
}));
